function loadScript(url, callback){
 
    var script = document.createElement("script")
    script.type = "text/javascript";
 
    if (script.readyState){  //IE
        script.onreadystatechange = function(){
            if (script.readyState == "loaded" ||
                    script.readyState == "complete"){
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function(){
            callback();
        };
    }
 
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
  loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
    jQuery191 = jQuery.noConflict(true);
    header(jQuery191);
    mobileMenu(jQuery191);
  });
} else {
  header(jQuery);
  mobileMenu(jQuery);
};



var header = function($){
  var headerHeight = $('header').outerHeight(true);
  var topRowHeight = $('.header-top-row').outerHeight(true);
  var bottomRowHeight = $('.header-bottom-row').outerHeight(true);

  stickyHeader(headerHeight, topRowHeight, bottomRowHeight);

  $(window).on('scroll', function(){
    stickyHeader(headerHeight, topRowHeight, bottomRowHeight);
  });

  $(window).on('resize', function(){
    stickyHeader(headerHeight, topRowHeight, bottomRowHeight);
  });
};


function stickyHeader(headerHeight, topRowHeight, bottomRowHeight) {
  
    if($(this).scrollTop() >= topRowHeight) {

      $('header').addClass('sticky').css('top', -(topRowHeight -1));
      $('body').css('padding-top', headerHeight);

    } else {

      $('header').removeClass('sticky').css('top', 0);
      $('body').css('padding-top', 0);
    }
}



var mobileMenu = function($){
  var mobileMenuButton = $('.mobile-menu__button');
  var mobileMenu = mobileMenuButton.parents('.mobile-menu');

  mobileMenuButton.on('click',function(){
    if(mobileMenu.hasClass('active')) {
        mobileMenu.removeClass('active');
    } else {
        mobileMenu.addClass('active');
    }
  });

  //stop propogation
  mobileMenu.on('click', function(e){
    e.stopPropagation();
  });

  $('body').on('click', function(){
   mobileMenu.removeClass('active');
  });
};
